<video #video [poster]="posterUrl" autoplay muted>
  <ng-container *ngFor="let source of sources; trackBy: trackBySource">
    <source [src]="source">
  </ng-container>
</video>

<div *ngIf="loading" [@loading]="" class="loading fill" fxLayout="column" fxLayoutAlign="center center">
  <mat-spinner color="accent"></mat-spinner>
</div>
